module.exports = __webpack_public_path__ + "static/img/20002 (5).de2a476.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20002 (5).webp
// module id = Ky7o
// module chunks = 14